import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { services } from "../data/site";

const Col = ({ title, children, testId }) => (
  <div data-testid={testId}>
    <h4 className="font-heading text-white text-sm font-semibold uppercase tracking-[0.18em] mb-5">
      {title}
    </h4>
    <ul className="space-y-3 text-[15px] text-[#CBD5E1]">{children}</ul>
  </div>
);

const FLink = ({ to, children, testId }) => (
  <li>
    <Link to={to} data-testid={testId} className="hover:text-white transition-colors">
      {children}
    </Link>
  </li>
);

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#070B22]" data-testid="footer">
      <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="container-x relative pt-16 pb-10">
        <div className="grid gap-12 md:grid-cols-4">
          <div data-testid="footer-brand-col">
            <Link
              to="/"
              data-testid="footer-logo-link"
              className="inline-block"
            >
              <img
                src="/digital-archdeacon-logo.png"
                alt="Digital Archdeacon Media Ltd"
                className="h-14 w-auto mb-5"
                style={{ filter: "drop-shadow(0 0 12px rgba(30,111,255,0.35))" }}
              />
            </Link>
            <p className="text-[#CBD5E1] leading-relaxed text-[15px] max-w-xs">
              Empowering Businesses and Organisations Through Technology and Media.
            </p>
          </div>

          <Col title="Company" testId="footer-company-col">
            <FLink to="/" testId="footer-link-home">Home</FLink>
            <FLink to="/about" testId="footer-link-about">About</FLink>
            <FLink to="/services" testId="footer-link-services">Services</FLink>
            <FLink to="/contact" testId="footer-link-contact">Contact</FLink>
            <FLink to="/request-quote" testId="footer-link-quote">Request a Free Quote</FLink>
          </Col>

          <Col title="Services" testId="footer-services-col">
            {services.map((s) => (
              <FLink key={s.id} to={`/services/${s.id}`} testId={`footer-svc-${s.id}`}>
                {s.title}
              </FLink>
            ))}
          </Col>

          <Col title="Get In Touch" testId="footer-contact-col">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-1 text-electric shrink-0" />
              <span>6 Edwin Amadi Street, One Day, Enugu, Nigeria</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-1 text-electric shrink-0" />
              <a href="mailto:info@digitalarchdeacon.com" className="hover:text-white">
                info@digitalarchdeacon.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-1 text-electric shrink-0" />
              <a href="tel:+2348147276648" className="hover:text-white">+234-814-727-6648</a>
            </li>
          </Col>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#CBD5E1]">
          <p>© 2026 Digital Archdeacon Media Ltd. All Rights Reserved.</p>
          <p>Powered by Digital Archdeacon Media Ltd</p>
        </div>
      </div>
    </footer>
  );
}
